import React from 'react'
import team_members from '../../assets/icons/team_members.svg'
import '../../assets/css/tags.css'
const AbsTag = () => {
  return (
    <img src={team_members}
      className='abs'
      onClick={(e) => e.stopPropagation()}
      />
  )
}

export default AbsTag;